import { OilContractStatusBase } from './base/oil-contract-status-base';

export class OilContractStatus extends OilContractStatusBase { }